import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getCancellationSettings(token) {
  const res = await axios.get(
    `${API}/online-booking/cancellations/settings`,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function updateCancellationSettings(payload, token) {
  const res = await axios.put(
    `${API}/online-booking/cancellations/settings`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function previewCancellationToken(payload, token) {
  const res = await axios.post(
    `${API}/online-booking/cancellations/preview-token`,
    payload || {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}
